import React from "react";

interface EmptyStateProps {
  heading: string;
  body: string;
  testId?: string;
}

const EmptyState = ({ heading, body, testId }: EmptyStateProps) => (
  <div className="padding--y--l" data-testid={testId}>
    <p className="fontColor--primary fontWeight--semibold margin--bottom--xs">
      {heading}
    </p>
    <p className="fontColor--secondary">{body}</p>
  </div>
);

export default EmptyState;
